/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Home from '@mui/icons-material/HomeRounded';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CenterFocusStrongRoundedIcon from '@mui/icons-material/CenterFocusStrongRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PhotoSizeSelectSmallRoundedIcon from '@mui/icons-material/PhotoSizeSelectSmallRounded';
import FlashOnRoundedIcon from '@mui/icons-material/FlashOnRounded';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import PresentToAllRoundedIcon from '@mui/icons-material/PresentToAllRounded';
import UnarchiveRoundedIcon from '@mui/icons-material/UnarchiveRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import PostAddIcon from '@mui/icons-material/PostAdd';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import InfoIcon from '@mui/icons-material/Info';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SvgIcon from '@mui/material/SvgIcon';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const VariableInsertIcon = () => (
  <SvgIcon>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
      <path d="M120-280v-400h720v160h-80v-80H200v240h360v80H120Zm80-80v-240 240Zm664 200L720-303v123h-80v-260h260v80H776l144 144-56 56Z" />
    </svg>
  </SvgIcon>
);
const ExportNotesIcon = () => (
  <SvgIcon sx={{ color: 'currentColor' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="m648-140 112-112v92h40v-160H640v40h92L620-168l28 28Zm-448 20q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z" />
    </svg>
  </SvgIcon>
);

const SweepIcon = () => (
  <SvgIcon sx={{ color: 'currentColor' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
    >
      <path d="M400-240v-80h240v80H400Zm-158 0L15-467l57-57 170 170 366-366 57 57-423 423Zm318-160v-80h240v80H560Zm160-160v-80h240v80H720Z" />
    </svg>
  </SvgIcon>
);

const MenuIcon = ({ iconName, onClick, id }) => {
  const [iconEl, setIconEl] = useState(null);
  const menuList = {
    home: <Home />,
    'open-menu': <ArrowForwardOutlinedIcon onClick={onClick} id={id} />,
    'close-menu': <ArrowBackOutlinedIcon onClick={onClick} id={id} />,
    'trans-create': <AddCircleOutlineRoundedIcon />,
    'package-create': <AddCircleRoundedIcon />,
    'package-separation': <AltRouteRoundedIcon />,
    'forming-loss-declare': <PostAddIcon />,
    'forming-stock': <FactCheckIcon />,
    'trans-export': <UnarchiveRoundedIcon />,
    'trans-report': <AssessmentOutlinedIcon />,
    'powder-info': <InfoIcon />,
    'powder-qc': <VariableInsertIcon />,
    'powder-export': <ExportNotesIcon />,
    'powder-qc-batch': <SweepIcon />,
    'powder-qc-upload': <UploadFileIcon />,
    'qc-forming': <CenterFocusStrongRoundedIcon />,
    'qc-sintering-inspection': <VisibilityOutlinedIcon />,
    'qc-sintering-size': <PhotoSizeSelectSmallRoundedIcon />,
    'qc-sintering-electrical': <FlashOnRoundedIcon />,
    'qc-sintering-ng': <BugReportRoundedIcon />,
    'qc-export': <PresentToAllRoundedIcon />,
    'qc-report': <AssessmentRoundedIcon />,
    'settings-privilege': <SupervisedUserCircleOutlinedIcon />,
    'settings-config': <SettingsRoundedIcon />,
    'system-key-in': <KeyboardIcon />,
    'pilot-trans-create': <AddBoxOutlinedIcon />,
    'pilot-trans-query': <AppRegistrationIcon />,
    'pilot-qc-sintering-size': <SquareFootIcon />,
    'pilot-qc-sintering-electrical': <BoltOutlinedIcon />,
    'pilot-trans-report': <DescriptionOutlinedIcon />,
  };

  useEffect(() => {
    setIconEl(menuList[iconName]);
  }, []);
  return iconEl !== null ? iconEl : '';
};

MenuIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export default MenuIcon;
